<template>
  <h2 style="text-align: center;">Products</h2>
  <form class="card col-md-10 offset-md-1">
    <div style="display: flex; align-self: center; margin: 20px">
      <div class="sync-btn" title="Sync products with shopify">
        <icon-svg class="icon-menu" :height="25" :width="25" style="margin-inline: 8px; cursor: pointer"
          icon="material-symbols:cloud-sync-rounded" @click="syncProducts()" />
      </div>
      <span v-if="showErrorMessage == true">Sync Error!</span>
      <span v-if="showSuccsesMessage == true">Sync Succsesfuly!</span>
    </div>
  </form>
  <h1>{{ this.store.countFilter }}/{{ this.store.countTotal }}</h1>
  <input type="checkbox" @change="() => { handleCheckboxChange() }" v-model="IsPending" />
  <label>IsPending</label>

  <div class="paginationButtons">
    <button @click="handleLeftButtonClick()" :disabled="currentPage === 1">
      <i class="fas fa-angle-left"></i>
    </button>
    <span>Page {{ currentPage }}</span>
    <button @click="handleRightButtonClick()" :disabled="currentPage === this.store.pageTotal">
      <i class="fas fa-angle-right"></i>
    </button>
  </div>
  <div class="row mt-2">
    <div class="col-md-8">
      <table class="table responsive-table">
        <thead>
          <tr>
            <th>
              <span>
                <MDBInput label="Search sku" type="text" v-model="searchSku" @keyup="search()" />
              </span>&nbsp;
              <div>Product sku</div>
            </th>
            <th>
              <span>
                <MDBInput label="Search id" type="text" v-model="searchId" @keyup="search()" />
              </span>&nbsp;
              <div>Product id</div>
            </th>
            <th>
              <span>
                <MDBInput label="Search name" type="text" v-model="searchProductName" @keyup="search()" />
              </span>&nbsp;
              <div>Product name</div>
            </th>
            <th>Preview</th>
            <th>Edit product</th>
          </tr>
        </thead>
        <tbody style="position: relative">
          <div v-if="store.allProducts.length == 0
          " style="width: 100%; position: absolute">
            &nbsp;
            <h4 style="color: red">There are no results for this search</h4>
          </div>
          <tr v-else v-for="(product, index) in store.allProducts" :key="index">
            <td class="col-md-4">
              {{ store.getAllProductSkus(product.productID) }}
            </td>
            <td class="col-md-2">{{ product.productName }}</td>
            <td style="display: flex; justify-content: center">
              <div class="emb-canvas-table" :style="{
                'background-image':
                  'url(' +
                  this.store
                    .getAllProductVariantImages(
                      product.productID,
                      Object.values(product.variants)[0].variantID
                    )[0]
                    .file.relativePath.replaceAll('\\', '\\\\') +
                  ')',
              }"></div>
              <!-- product.variants[
                      Object.keys(product.variants)[0]
                    ].oadile.relativePath.replaceAll('\\', '\\\\') + -->
            </td>
            <td class="col-md-2">
              <icon-svg icon="line-md:edit"
                :style=" { 'color': store.getAllProductVariantUsefulImages(product.productID, Object.values(product.variants)[0].variantID).length == 0 ? 'red' : 'black' }"
                height="25" width="25" style="cursor: pointer" @click="(editProductOpen = true), editProduct(product)" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <MDBModal staticBackdrop id="editProductOpen" tabindex="-1" labelledby="editProductOpenLabel" v-model="editProductOpen" centered
    scrollable>
    <!-- staticBackdrop -->
    <MDBModalHeader :close="false" >
    <MDBModalTitle id="editProductOpenLabel" :style="{ width: '100%' }">
        <div style="width: 100%; display: block">
          <h4 class="modal-title">
            {{ productToPopup.productName }}
          </h4>
        </div>
      </MDBModalTitle>
    </MDBModalHeader>

    <MDBModalBody style="overflow-y: auto">
    <div class="row">
      <div class="col-md-6">
        <div v-if="productToPopup.variants != null">
          <div class="row">
            <div class="col-md-6" style="display: grid">
              <div>Variant name</div>
              <div style="
              /* height: 500px; */
               overflow-y: scroll; display: grid; height: calc(90vh - 73px - 58px - 26px - 61px)">
                <div v-for="(variant, index) in store.getAllProductVariants(
                  productToPopup.productID
                )" :key="index" @click="selectVariant(variant)" :id="variant == variantPreview ? 'activeVariant' : ''"
                  class="badge-style badge rounded-pill bg-info text-dark" style="margin: 10px; height: 40px">
                  sku = {{ variant.sku }}
                  <br />
                  variant: {{ variant.variantName }}
                  <!-- @click="editImageProduct(image)"
              :class="image == imagePreview ? 'activeLine' : 'null'"
              class="badge-color badge rounded-pill bg-info text-dark" -->
                </div>
              </div>
            </div>
            <div class="col-md-4" style="display: grid">
              <div>Images</div>

              <div v-if="variantPreview != null" style="overflow-y: scroll;
              /* height: 500px; */
               display: grid; height: calc(90vh - 73px - 58px - 26px - 61px)">

                <div v-for="(image, index) in store.getAllProductVariantImages(
                  productToPopup.productID,
                  variantPreview.variantID
                )" :key="index" :id="image == imagePreview ? 'activeImage' : ''"
                  style="text-align: -webkit-center; border: #96b17f 2px solid; height: max-content;"
                  @click="editImageProduct(image)">
                  <div>
                    <div class="emb-canvas-table" :style="{
                      'background-image':
                        'url(' +
                        image.file.relativePath.replaceAll('\\', '\\\\') +
                        ')',
                    }"></div>

                    {{ image.imageName }}
                  </div>
                  <div style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    ">
                    <MDBCheckbox style="width: 10px; height: 10px" label="is image useful?" v-model="image.isUseful" />
                  </div>

                  <!-- <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="image.isUseful"
                    />
                  </div> -->
                </div>
              </div> 
              <a></a>
            </div>
            <div class="col-md-2" style="display: grid">
              <div>Inches</div>
              &nbsp;
              <div v-if="imagePreview != null" style="
              height: calc(90vh - 73px - 58px - 26px - 61px);
              /* height: 500px */
              ">
                <div>
                  <input class="form-control" type="number" :value="imagePreview.box.widthInches"
                    @change="changeWidth($event)" />
                  width
                </div>
                &nbsp;
                <div>
                  <input class="form-control" type="number" :value="imagePreview.box.heightInches"
                    @change="changeHeight($event)" />
                  height
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div style="display: flex;
    padding-inline: 20px;
    flex-direction: row-reverse;
    gap: 10px;">
          <span title="copy box">
            <icon-svg :height="30" :width="30" style="cursor: pointer" icon="icon-park-outline:copy-one" @click="saveBox()" />
          </span>
          &nbsp;
          <span title="paste box">
            <icon-svg :height="30" :width="30" style="cursor: pointer"  icon="fontisto:paste" @click="getLastBox()" />
          </span>
          <!-- add vue-select productMaterial from store.getAllMaterials() -->
          <div>
            Select materials for product: 
          <vue-select              
              :close-on-select="true"
              :options="materialSource"
              label-by="materialName"
              value-by="materialID"
              searchable              
              :model-value="productToPopup.productMaterial"
              @update:modelValue="(value) => {
                if (value !== null && value !== undefined) { 
                  productToPopup.productMaterial = value;}
                }"
                multiple
                taggable
            ></vue-select>
          </div>
        </div>
        <div style="display: flex; gap: 20px; flex-wrap: wrap;">
          <!-- Embroidery
          WoodEngrave
          GlassEngrave
          ColorSticker -->

          <span>
            <input type="radio" id="embroidery" value="Embroidery" v-model="productToPopup.productType" />
            <label for="embroidery">Embroidery</label>
          </span>
          
          <span>
            <input type="radio" id="woodEngrave" value="WoodEngrave" v-model="productToPopup.productType" />
            <label for="woodEngrave">WoodEngrave</label>
          </span>

          <span>
            <input type="radio" id="glassEngrave" value="GlassEngrave" v-model="productToPopup.productType" />
            <label for="glassEngrave">GlassEngrave</label>
          </span>
          
          <span>
            <input type="radio" id="colorSticker" value="ColorSticker" v-model="productToPopup.productType" />
            <label for="colorSticker">ColorSticker</label>
          </span>  

          </div>
          <!-- {{ dpi }} dmmY# {{ imagePreview.box.topLeftDmm.y * (dpi / 254.0) }} #dmmX {{ imagePreview.box.topLeftDmm.x * (dpi / 254.0) }} -->
        <div style="position: relative;">
          <div :key="imgKey" ref="embCanvasProduct" class="emb-canvas" :style="{
            'background-image':
              'url(' +
              imagePreview.file.relativePath.replaceAll('\\', '\\\\') +
              ')',
            position: 'relative',
          }">
          <!-- :w="initialBox.widthInches * dpi" :h="initialBox.heightInches * dpi"
          :x="initialBox.topLeftDmm.x * (dpi / 254.0)" :y="initialBox.topLeftDmm.y * (dpi / 254.0)" -->
            <vue-draggable-resizable class="boxDrag" :parent="true" :lock-aspect-ratio="isRatio"
              :w="imagePreview.box.widthInches * dpi" :h="imagePreview.box.heightInches * dpi"
              :x="imagePreview.box.topLeftDmm.x * (dpi / 254.0)" :y="imagePreview.box.topLeftDmm.y * (dpi / 254.0)"
              @resizing="onResize" @dragging="onDrag" style="border-color: #ffc107" :key="dragKey">
              <p>Place the box </p>
            </vue-draggable-resizable>
          <!-- {{ imagePreview.box.topLeftDmm.y * (dpi / 254.0) }} -->
          </div>
        </div>
      </div>
    </div>
  </MDBModalBody>
    <MDBModalFooter>
      <!-- <MDBBtn color="secondary" @click="editProductOpen = false">Close</MDBBtn> -->

      <MDBBtn color="secondary" @click="saveProductInfoBox">save</MDBBtn>
      <MDBBtn color="secondary" @click="editProductOpen = false">cancel</MDBBtn>

    </MDBModalFooter>
  </MDBModal>
</template>


<script>
import { designerStore } from "@/stores/designerStore";
import VueDraggableResizable from 'vue-draggable-resizable'
import { nextTick } from "vue-demi";
import { ref } from "vue";
import {
  MDBModal,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn,
  MDBInput,
  MDBCheckbox,
} from "mdb-vue-ui-kit";
import VueSelect from "vue-next-select";


export default {
  setup() {
    const store = designerStore();
    const editProductOpen = ref(false);
    const IsPending = ref(false)
    return {
      store,
      editProductOpen,
      currentPage: 1,
      IsPending
    };
  },
  components: {
    VueDraggableResizable,
    MDBModal,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBBtn,
    MDBInput,
    MDBCheckbox,
    VueSelect,
  },
  data() {
    return {
      showErrorMessage: false,
      showSuccsesMessage: false,
      page: 1,

      width: 0,
      height: 0,
      top: 0,
      left: 0,
      frame: {
        translate: [0, 0],
      },

      imgContent: "",
      productName: "",
      productImageName: "",
      skuProduct: null,
      productMaterial: [],

      ImageNameNew: "",
      widthInchesNew: 1,
      heightInchesNew: 1,

      // allProductList: {},
      searchId: "",
      searchSku: "",
      searchProductName: "",

      productToPopup: null,
      productPopupOpen: false,
      productPopupCount: 0,

      calcImgInches: false,
      calcImgInchesCount: 0,
      dpi: 100,
      isRatio: true,
      variantPreview: {},
      imagePreview: {},
      dragKey: 0,
      imgKey: 0,
      materialSource: [],
      addImageToProductOpen: false,
      movLeft: 0,
      movRight: 0,
      movBottom: 0,
      movTop: 0,
      // initialBox: { widthInches: 1, heightInches: 1, topLeftDmm: { x: 0, y: 0 } }
    };
  },
  mounted() {

    window.addEventListener("resize", this.eventHandler);

    // this.allProductList = this.store.getAllProducts();

    // this.materialSource = Object.values(this.store.allMaterials.value);
    
    this.materialSource = this.store
      .getAllMaterials()
      .map((x) => ({ materialID: x.materialID, materialName: x.materialName }));

    // this.materialSource.push({
    //   materialID: -1,
    //   materialName: "None",
    //   fontsToExcludeID: [-1],
    // });

    // this.variantPreview = {
    //   variantID: null,
    //   sku: null,
    //   images: {},
    // };

    // this.imagePreview = {
    //   file: null,
    //   box: {
    //     widthInches: 0,
    //     heightInches: 0,
    //     // widthPixel: 100,
    //     // heightPixel: 100,
    //     topLeftDmm: { x: 0, y: 0 },
    //   },
    //   widthInches: 1,
    //   heightInches: 1,
    // };
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.eventHandler);
  },

  methods: {
    async syncProducts() {
      try {
        await this.store.syncShopifyProduct();
      } catch (error) {
        this.showErrorMessage = true;
        this.showSuccsesMessage = false;
        setTimeout(() => {
          this.showErrorMessage = false;
        }, 5000);
      }
      this.showSuccsesMessage = true;
      this.showErrorMessage = false;
      setTimeout(() => {
        this.showSuccsesMessage = false;
      }, 5000);
    }, //await this.store.syncShopifyProduct();
    async eventHandler() {
      if (this.editProductOpen) {
        await this.calculateDpiByImg();
      }
    },
    // uploadNewPicture(event) {
    //   const reader = new FileReader();
    //   reader.onload = () => {
    //     this.imgContent = reader.result;
    //   };
    //   reader.readAsDataURL(event.target.files[0]);
    // },
    // removeProduct(product) {
    //   this.store.removeProduct(product.productID);
    // },
    async calculateDpiByBox() {
      await nextTick();
      const boxSize = this.$refs.embCanvasProduct
        .querySelector(".boxDrag")
        .getBoundingClientRect();
      this.dpi =
        parseFloat(boxSize.width) /
        parseFloat(this.imagePreview.box.widthInches);
    },
    async calculateDpiByImg() {
      await nextTick();
      const imgSize = this.$refs.embCanvasProduct.getBoundingClientRect();
      var imgRatioFromHtml = imgSize.width / imgSize.height;
      var imgRatio =
        this.imagePreview.file.pixelWidth / this.imagePreview.file.pixelHeight;
      var width =
        imgRatio < imgRatioFromHtml ? imgSize.height * imgRatio : imgSize.width;
      this.dpi =
        parseFloat(width) / parseFloat(this.imagePreview.imgWidthInches);
    },
    async editProduct(product) {
      console.log(product)
      this.productToPopup = product;
      if(this.productToPopup.productMaterial=='None'){
        this.productToPopup.productMaterial=[];
      }
      console.log(this.productToPopup);
      this.variantPreview = Object.values(this.productToPopup.variants)[0];
      this.imagePreview = Object.values(this.variantPreview.images)[0];
      // this.initialBox={widthInches:this.imagePreview.box.widthInches,heightInches:this.imagePreview.box.heightInches,topLeftDmm:{x:this.imagePreview.box.topLeftDmm.x,y:this.imagePreview.box.topLeftDmm.y}}
      // console.log(this.initialBox)
      // this.productPopupOpen = true;
      // this.productPopupCount++;
      await nextTick();
      await this.calculateDpiByImg();
      this.dragKey++;
      // this.store.allProducts=product
      // await nextTick();
      // this.getImageDimensions();
    },
    async editImageProduct(image) {
      this.imagePreview = image;
      await nextTick();
      await this.calculateDpiByImg();
      this.dragKey++;
    },
    // async editVariantProduct(variant) {
    //   this.variantPreview = variant;
    //   // await this.calculateDpiByImg();
    //   // this.dragKey++;
    // },
    async selectVariant(variant) {
      this.variantPreview = variant;
      this.imagePreview = Object.values(this.variantPreview.images)[0];
      await this.calculateDpiByImg();
      this.dragKey++;
    },

    // async removeImage(image) {
    //   if (
    //     Object.values(
    //       this.store.allProducts[this.productToPopup.productID].images
    //     ).length > 1
    //   ) {
    //     this.store.removeImageFromProduct(
    //       this.productToPopup.productID,
    //       image.imageName
    //     );
    //     await nextTick();
    //     this.imagePreview = Object.values(this.productToPopup.images)[0];
    //     await this.calculateDpiByImg();
    //     this.imgKey++;
    //   } else {
    //     console.log("can not delete the last image");
    //   }
    // },
    // addImageOpen() {
    //   this.addImageToProductOpen = true;
    // },
    // async addImageToProduct() {
    //   await nextTick();
    //   const imgSize = this.$refs.embCanvasProduct.getBoundingClientRect();
    //   await nextTick();
    //   const boxSize = this.$refs.embCanvasProduct
    //     .querySelector(".boxDrag")
    //     .getBoundingClientRect();
    //   await this.store.addImageToProduct(
    //     this.productToPopup.productID,
    //     this.imgContent,
    //     this.heightInchesNew,
    //     this.widthInchesNew,
    //     parseFloat(imgSize.height) /
    //       (boxSize.height / this.imagePreview.box.heightInches),
    //     parseFloat(imgSize.width) /
    //       (boxSize.width / this.imagePreview.box.widthInches),
    //     this.ImageNameNew
    //   );
    //   this.imgContent = null;
    //   this.productName = "";
    //   this.skuProduct = "";
    //   this.widthInchesNew = 0;
    //   this.heightInchesNew = 0;
    //   this.ImageNameNew = "";
    //   this.addImageToProductOpen = false;
    // },
    // exitPopup() {
    //   this.productPopupOpen = false;
    // },
    // getAllMaterialNamesAndNone() {
    //   var list = Object.values(this.store.allMaterials);
    //   list.push({
    //     materialName: "None",
    //     fontsToExcludeID: [-1],
    //   });
    //   return list;
    // },
    async onDrag(x, y) {
      const left = x;
      const top = y;
      await this.calculateDpiByBox();
      this.imagePreview.box.topLeftDmm.x = left * (254.0 / this.dpi);
      this.imagePreview.box.topLeftDmm.y = top * (254.0 / this.dpi);    
        console.log(this.imagePreview.box )

    },
    async onResize(el) {
      await this.calculateDpiByBox();
      this.w = el.width;
      this.h = el.height;
      this.imagePreview.box.topLeftDmm.x = (el.left * 254.0) / this.dpi;
      this.imagePreview.box.topLeftDmm.y = (el.top * 254.0) / this.dpi;
      console.log(this.imagePreview.box)

      await this.saveImgInches();

      // const boxSize = this.$refs.embCanvasProduct.querySelector('.boxDrag').getBoundingClientRect();
      // await nextTick();
      // //שליפת גודל הבוקס
      // const imgSizeFromHtml = this.$refs.embCanvasProduct.getBoundingClientRect();

      // var imgRatioFromHtml = imgSizeFromHtml.width / imgSizeFromHtml.height;
      // var imgRatio = this.imagePreview.file.pixelWidth / this.imagePreview.file.pixelHeight;

      // var width =
      //   imgRatio < imgRatioFromHtml
      //     ? this.imagePreview.imgWidthInches *
      //       (imgSizeFromHtml.height / this.imagePreview.imgHeightInches)
      //     : imgSizeFromHtml.width;

      // var height =
      //   imgRatio < imgRatioFromHtml
      //     ? imgSizeFromHtml.height
      //     : this.imagePreview.imgHeightInches *
      //       (imgSizeFromHtml.width / this.imagePreview.imgWidthInches);

      // this.imagePreview.imgWidthInches = width / this.dpi;
      // this.imagePreview.imgHeightInches = height / this.dpi;
    },
    async saveImgInches() {
      await nextTick();
      //שליפת גודל התמונה
      const imgSizeFromHtml =
        this.$refs.embCanvasProduct.getBoundingClientRect();

      var imgRatioFromHtml = imgSizeFromHtml.width / imgSizeFromHtml.height;
      var imgRatio =
        this.imagePreview.file.pixelWidth / this.imagePreview.file.pixelHeight;

      var width =
        imgRatio < imgRatioFromHtml
          ? imgSizeFromHtml.height * imgRatio
          : imgSizeFromHtml.width;

      var height =
        imgRatio < imgRatioFromHtml
          ? imgSizeFromHtml.height
          : imgSizeFromHtml.width * imgRatio;

      this.imagePreview.imgWidthInches = width / this.dpi;
      this.imagePreview.imgHeightInches = height / this.dpi;

      // var width =
      //   imgRatio < imgRatioFromHtml
      //     ? this.imagePreview.imgWidthInches *
      //       (imgSizeFromHtml.height / this.imagePreview.imgHeightInches)
      //     : imgSizeFromHtml.width;

      // var height =
      //   imgRatio < imgRatioFromHtml
      //     ? imgSizeFromHtml.height
      //     : this.imagePreview.imgHeightInches *
      //       (imgSizeFromHtml.width / this.imagePreview.imgWidthInches);
    },
    async changeWidth(event) {
      this.isRatio = false;
      let newValue = parseFloat(event.target.value);
      if (newValue == 0) {
        newValue = 1;
      }
      // this.imagePreview.box.widthPixel = (image.box.widthPixel / image.box.widthInches) * newValue;
      this.imagePreview.box.widthInches = newValue;
      // this.imagePreview.box.heightPixel = this.imagePreview.box.heightInches * (this.imagePreview.box.widthPixel  / this.imagePreview.box.widthInches  );
      await nextTick();
      this.isRatio = true;
      await this.calculateDpiByBox();
    },
    async changeHeight(event) {
      this.isRatio = false;
      let newValue = parseFloat(event.target.value);
      if (newValue == 0) {
        newValue = 1;
      }
      // this.imagePreview.box.heightPixel = (image.box.heightPixel / image.box.heightInches) * newValue;
      this.imagePreview.box.heightInches = newValue;
      // this.imagePreview.box.widthPixel = this.imagePreview.box.widthInches * (this.imagePreview.box.heightPixel /this.imagePreview.box.heightInches );

      await nextTick();
      this.isRatio = true;
    },
    async saveBox() {
      this.store.lastCopyBox.box = JSON.parse(
        JSON.stringify(this.imagePreview.box)
      );
      this.store.lastCopyBox.dpi = JSON.parse(JSON.stringify(this.dpi));
    },
    async getLastBox() {
      this.imagePreview.box = JSON.parse(
        JSON.stringify(this.store.lastCopyBox.box)
      );
      this.dpi = JSON.parse(JSON.stringify(this.store.lastCopyBox.dpi));
      await nextTick();
      await this.saveImgInches();
      this.dragKey++;
      // await this.calculateDpiByImg();
      // this.dragKey++;
      // await this.calculateDpiByBox();
      // this.dragKey++;
    },
    async saveProductInfoBox(){
     var selectedVariant= Object.values(this.productToPopup.variants).find(v=>v.variantID==this.variantPreview.variantID)
     if (selectedVariant){
      var selectedImage = Object.values(selectedVariant.images).find(image => image.imageID === this.imagePreview.imageID);
     if (selectedImage) 
      selectedImage.box=this.imagePreview.box
    }
    var IsPending=await this.store.checkIsPending(this.productToPopup)
    await this.store.updateProductInfoBox(this.productToPopup,IsPending)
    this.editProductOpen=false;
  },
    
    async handleLeftButtonClick() {
      try {
        if (this.currentPage > 1) {
          const allDetails = await this.store.getAllProductsInfo(this.currentPage - 1, 20, this.searchId, this.searchSku, this.searchProductName, this.IsPending)
          this.store.allProducts = JSON.parse(allDetails.allProducts)
          this.store.countFilter = allDetails.countFilter
          this.store.countTotal = allDetails.countTotal
          this.store.pageTotal = Math.ceil(this.store.countFilter / 20)
          this.currentPage -= 1;
        }
      } catch (error) {
        console.error('Failed to fetch products:', error);
      }
    },
    async handleRightButtonClick() {
      try {
        if (this.currentPage <= this.store.pageTotal) {
          const allDetails = await this.store.getAllProductsInfo(this.currentPage + 1, 20, this.searchId, this.searchSku, this.searchProductName, this.IsPending)
          this.store.allProducts = JSON.parse(allDetails.allProducts)
          this.store.countFilter = allDetails.countFilter
          this.store.countTotal = allDetails.countTotal
          this.store.pageTotal = Math.ceil(this.store.countFilter / 20)
          this.currentPage += 1;
        }
      } catch (error) {
        console.error('Failed to fetch products:', error);
      }
    },
    async search() {
      try {
        this.currentPage = 1
        const allDetails = await this.store.getAllProductsInfo(1, 20, this.searchId, this.searchSku, this.searchProductName, this.IsPending)
        this.store.allProducts = JSON.parse(allDetails.allProducts)
        this.store.countFilter = allDetails.countFilter
        this.store.countTotal = allDetails.countTotal
        this.store.pageTotal = Math.ceil(this.store.countFilter / 20)
      } catch (error) {
        console.error('Failed to fetch products:', error);
      }
    },
    async handleCheckboxChange() {
      this.IsPending = event.target.checked
      const allDetails = await this.store.getAllProductsInfo(this.currentPage, 20, this.searchId, this.searchSku, this.searchProductName, this.IsPending)
      this.store.allProducts = JSON.parse(allDetails.allProducts)
      this.store.countFilter = allDetails.countFilter
      this.store.countTotal = allDetails.countTotal
      this.store.pageTotal = Math.ceil(this.store.countFilter / 20)
    }
  },

};
</script>

<style scoped>
.emb-canvas {
  height: 400px;
  background-position: unset;
  /* max-width: 400px; */
  background-size: contain;
  position: absolute;
  top: 0px;
  left: 0px;
}

.emb-canvas-table {
  height: 80px;
  width: 80px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: block;
}

.moveable {
  position: absolute;
  /* --moveable-color: transparent !important; */
}

.activeLine {
  background-color: rgb(213, 228, 236);
}

#activeVariant {
  background-color: rgb(185, 218, 205) !important;
}

#activeImage {
  border-color: rgb(185, 218, 205) !important;
}

.badge-style {
  background-color: #96b17f !important;
  font-size: 14px;
}

.sync-btn :hover {
  background-color: aliceblue;
}

.paginationButtons {
  display: flex;
  align-items: center;
}

button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
}

button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}
.boxDrag {
  border-color: yellow;
  border-style: dashed;
  position: absolute;
}
</style>
